import { render, staticRenderFns } from "./transferTicket.vue?vue&type=template&id=de7f1f3a&scoped=true"
import script from "./transferTicket.vue?vue&type=script&lang=js"
export * from "./transferTicket.vue?vue&type=script&lang=js"
import style0 from "./transferTicket.vue?vue&type=style&index=0&id=de7f1f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7f1f3a",
  null
  
)

export default component.exports